import React from 'react';
import { NumberInputV2, ParagraphMedium } from '../../../../../core/components';
import { ModalSubSection } from '../modal-sub-section';
import type { ModalProps } from './patient-settings-modal';

const getNextValue = (value: number, defaultCardiacPhaseParameters: string): string => {
  if (isNaN(value)) return defaultCardiacPhaseParameters;
  if (value < 1) return '1';
  if (value > 20) return '20';
  return value.toString();
};

type CardiacPhaseSubSectionProps = Pick<ModalProps, 'onDefaultCardiacPhaseChange'> & {
  defaultCardiacPhaseParameters?: string;
  defaultConfigurationSettingsSelected: boolean;
};

export const CardiacPhaseSubSection = ({
  defaultCardiacPhaseParameters = '1',
  defaultConfigurationSettingsSelected,
  onDefaultCardiacPhaseChange,
}: CardiacPhaseSubSectionProps): JSX.Element => {
  return (
    <ModalSubSection title="Cardiac phase">
      <div className="d-flex flex-column mt-2">
        <ParagraphMedium>
          Defines the default cardiac phase. End-diastole is considered for cardiac phases 17, 18, 19 and 20.
        </ParagraphMedium>
        <NumberInputV2
          min={1}
          max={20}
          disabled={defaultConfigurationSettingsSelected}
          defaultValue={parseInt(defaultCardiacPhaseParameters, 10)}
          onBlur={(event) => {
            const newValue = parseInt(event.target.value, 10);
            const nextValue = getNextValue(newValue, defaultCardiacPhaseParameters);
            event.target.value = nextValue;
            onDefaultCardiacPhaseChange({ default_cardiac_phase_value: nextValue });
          }}
        />
      </div>
    </ModalSubSection>
  );
};
